<template>
  <div class="flex-shrink-2 pr-1 pt-2 pb-2" v-if="!!subMenu.name">
    <!--<router-link :to="chooseFood ? `/submit-order/menu/1/1` : `/shop/rmmahryar/menu/1/1`"
                 :class="[subMenu.name===CurrentSubMenu ? 'bg-green-600 rounded-lg px-2 py-1 text-white' : 'bg-green-700 rounded-lg px-2 py-1']">
      {{ subMenu.name }}
    </router-link>-->
    <button 
                class="text-white  text-center text-xs rounded-lg  "
                :class="[subMenu.name===CurrentSubMenu ? 'bg-purple-400  text-xs rounded-lg  px-2 py-4 text-white ' : 'bg-purple-400  text-xs rounded-lg px-2 py-4']">
      {{ subMenu.name }}
    </button>    
  </div>
  
</template>

<script>

export default {
  name: "SubMenuCard",
  props: ['subMenu','CurrentSubMenu'],
  data() {
    return {
      chooseFood: false
    }
  },
  created() {
    //console.log(2000);
    if (this.$route.matched.some(record => record.name === 'ChooseFood')) {
      this.chooseFood = true
    }
  }
}
</script>

<style scoped>

</style>